import { currency } from "@/common/utils/assist.js";
export const BUDGET_LIST = [
    {
        label: '预算一级部门',
        prop: 'firstDeptName',
        // width: 130,
    },
    {
        label: '预算大类',
        prop: 'type',
        width: 135,
    },
    {
        label: '预算类型',
        prop: 'childType',
        // width: 140,
    },
    {
        label: '年份',
        prop: 'budgetCycleYear',
        // width: 120
    },
    {
        label: '预算周期',
        prop: 'budgetYearMonth',
        formatter: (budgetYearMonth) => {
            if (budgetYearMonth) {
                budgetYearMonth = budgetYearMonth.toString()
                return budgetYearMonth.slice(0, 4) + '年' + budgetYearMonth.slice(4, 6) + '月'
            } else {
                return '--'
            }
        },
        width: 120,
    },
    {
        label: '预算编制金额',
        prop: 'amount',
        width: 120,
        formatter: (amount) => {
            return currency(amount)
        },
    },
    {
        label: '编制金额（分摊出去）',
        prop: 'spreadOutAmount',
        width: 170,
        formatter: (spreadOutAmount) => {
            return currency(spreadOutAmount)
        },
    },
    {
        label: '预算已调整金额',
        prop: 'adjustedAmount',
        width: 120,
        formatter: (adjustedAmount) => {
            return currency(adjustedAmount)
        },
    },
    {
        label: '调整金额（分摊出去）',
        prop: 'adjustedSpreadOutAmount',
        width: 170,
        formatter: (adjustedSpreadOutAmount) => {
            return currency(adjustedSpreadOutAmount)
        },
    },
    {
        label: '预算已执行金额',
        prop: 'executedAmount',
        width: 180,
        type: 'CUSTOM'
        // formatter: (executedAmount) => {
        //     return currency(executedAmount)
        // },
    },
    {
        label: '预算已冻结金额',
        prop: 'fronzenAmount',
        width: 180,
        type: 'CUSTOM'
        // formatter: (fronzenAmount) => {
        //     return currency(fronzenAmount)
        // },
    },
    {
        label: '预算剩余金额',
        prop: 'remainAmount',
        width: 120,
        formatter: (remainAmount) => {
            return currency(remainAmount)
        },
    }
]


export const EXEC_LIST = [
    {
        label: '预算一级部门',
        prop: 'firstDeptName',
        // width: 130,
    },
    {
        label: '预算大类',
        prop: 'type',
        // width: 135,
    },
    {
        label: '预算类型',
        prop: 'childType',
        // width: 140,
    },
    {
        label: '年份',
        prop: 'budgetCycleYear',
        // width: 120
    },
    {
        label: '预算周期',
        prop: 'budgetYearMonth',
        width: 120,
    },
    {
        label: '预算已执行金额',
        prop: 'operationPrice',
        width: 180,
        // type: 'CUSTOM'
        formatter: (operationPrice) => {
            return currency(operationPrice)
        },
    },
    {
        label: '业务单号',
        prop: 'sourceNum',
        width: 180,
        // type: 'CUSTOM'
        // formatter: (fronzenAmount) => {
        //     return currency(fronzenAmount)
        // },
    },
    {
        label: '备注',
        prop: 'operationDetail',
        // width: 120,
    }
]

export const FORZEN_LIST = [
    {
        label: '预算一级部门',
        prop: 'firstDeptName',
        // width: 130,
    },
    {
        label: '预算大类',
        prop: 'type',
        // width: 135,
    },
    {
        label: '预算类型',
        prop: 'childType',
        // width: 140,
    },
    {
        label: '年份',
        prop: 'budgetCycleYear',
        // width: 120
    },
    {
        label: '预算周期',
        prop: 'budgetYearMonth',
        width: 120,
    },
    {
        label: '预算已冻结金额',
        prop: 'operationPrice',
        width: 180,
        // type: 'CUSTOM'
        formatter: (operationPrice) => {
            return currency(operationPrice)
        },
    },
    {
        label: '业务单号',
        prop: 'sourceNum',
        width: 180,
        // type: 'CUSTOM'
        // formatter: (fronzenAmount) => {
        //     return currency(fronzenAmount)
        // },
    },
    {
        label: '备注',
        prop: 'operationDetail',
        // width: 120,
    }
]